import "./../bindings/bao-tree";
import "./../bindings/bao-pager";
import "./../bindings/sorting";
// bao migrate - module not found: import "services/bao-template-engine";
import Bao from "./../services/bao-service";
import * as ko from "knockout";
import TreeNodeViewModel from "./../factories/tree-node";
import NodeViewModel from "./../factories/node-view-model";
import Guid from "./../factories/guid";
import BaoMenu from "./../services/bao-menu";
import baoRouter from "./../services/bao-router";
import AppTabController from "./../services/app-tab-controller";
class ExplorerViewModel {
    subscriptions = [];
    resetInProgress = false;
    ExplorerTypeId = ko.observable();
    SelectedExplorerType = ko.observable<any>();
    ExplorerTypes = ko.observableArray([]);
    HierarchyId = ko.observable();
    ExplorerHierarchy = ko.observableArray([]);
    FilterId = ko.observable();
    ExplorerFilters = ko.observableArray([]);
    LayoutId = ko.observable();
    ExplorerLayouts = ko.observableArray([]);
    EnableLayout = ko.observable(true);
    EnableFilter = ko.observable(true);
    EnableTree = ko.observable(true);
    OpenAllowed = ko.observable();
    PageIndex = ko.observable(0);
    PageSize = ko.observable(50);
    TotalRows = ko.observable(0);
    Sorting = ko.observableArray();
    SelectedNode = ko.observable<any>();
    Models = ko.observableArray();
    Columns = ko.observableArray();
    SelectedRow = ko.observable();
    Nodes = ko.observableArray([]);
    Initialized = ko.observable(false);
    TemplateName = ko.observable();
    AllowedPermissions = ko.observableArray([]);
    /** Instance of QuickFilter's ViewModel, defined in this.QuickFilterTemplate
     */
    QuickFilter = ko.observable();
    /** Path to a QuickFilter-ViewModel - if it changes, a subscription will window.baorequire the viewmodel
     */
    QuickFilterTemplate = ko.observable<string>();
    /** Name of the current QuickFilter's Template
     */
    QuickFilterTemplateName = ko.observable();
    /** Will be set by QuickFilter's ViewModel, when it changes, the tree will be reset
     */
    QuickFilterJson = ko.observable();
    TabPage;
    _ignorePageIndexChange = false;
    constructor(tabPage) {
        this.TabPage = tabPage;
        // reset tree when quickfilter changes
        this.subscriptions.push(this.QuickFilterJson.subscribe((newValue) => {
            this.ResetTreeAndGrid();
        }));
        // reset explorer when explorer-type changes
        this.subscriptions.push(this.ExplorerTypeId.subscribe((newValue) => {
            let explorerType = this.GetExplorerTypeObject(newValue);
            this.SelectedExplorerType(explorerType);
            if (this.Initialized()) {
                this.ResetExplorer();
            }
        }));
        // reset/set vars, when the explorer - object c
        this.subscriptions.push(this.SelectedExplorerType.subscribe((newValue) => {
            this.EnableFilter(newValue.EnableFilter);
            this.EnableTree(newValue.EnableTree);
            this.EnableLayout(newValue.EnableLayout);
            this.TabPage.Title(newValue.ExplorerTitle);
            this.UpdateHash();
        }));
        this.subscriptions.push(this.SelectedNode.subscribe((newValue) => {
            if (newValue != null && this.resetInProgress == false) {
                this._ignorePageIndexChange = true;
                this.PageIndex(0);
                this.RefreshData();
                this._ignorePageIndexChange = false;
            }
        }));
        this.subscriptions.push(this.PageIndex.subscribe(() => {
            if (this._ignorePageIndexChange == false && this.resetInProgress == false) {
                this.RefreshData();
            }
        }));
        this.subscriptions.push(this.PageSize.subscribe(() => {
            if (this._ignorePageIndexChange == false && this.resetInProgress == false) {
                this.RefreshData(true);
            }
        }));
        this.subscriptions.push(this.Sorting.subscribe((newValue) => {
            if (newValue != null && this.resetInProgress == false) {
                this.RefreshData();
            }
        }));
        this.subscriptions.push(this.FilterId.subscribe(() => {
            this.ResetTreeAndGrid();
        }));
        this.subscriptions.push(this.HierarchyId.subscribe(() => {
            this.ResetTreeAndGrid();
        }));
        this.subscriptions.push(this.LayoutId.subscribe(() => {
            this.ResetTreeAndGrid();
        }));
        this.subscriptions.push(this.AllowedPermissions.subscribe(() => {
            this.TogglePermissions();
        }));
        this.subscriptions.push(this.TabPage.IsActiveTab.subscribe((isActive) => {
            if (isActive == false) {
                return;
            }
            this.TogglePermissions();
        }));
        // when the QuickFilter's ViewModel path changes
        this.subscriptions.push(this.QuickFilterTemplate.subscribe((newValue) => {
            // if ViewModel-path is unset, unset template name & quickfilter-instance
            if (Bao.Utils.String.IsNullOrEmpty(newValue)) {
                this.QuickFilterTemplateName("");
                this.QuickFilterTemplate(""); //null=>""
                this.QuickFilter(null);
            }
            else {
                window.baorequire([newValue], (factory) => {
                    // unset/clear template name to avoid ko-binding issues
                    this.QuickFilterTemplateName("");
                    let inst = new factory(this);
                    this.QuickFilter(inst);
                    inst.init();
                });
            }
        }));
        BaoMenu.registerEvent((value) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                Bao.post("Explorer/CallAction", JSON.stringify({ explorerTypeId: this.ExplorerTypeId(), actionKey: value.ActionKey() }), (result) => {
                    if (!Bao.Utils.String.IsNullOrEmpty(result)) {
                        window.baorequire([result], (factory) => {
                            let inst = new factory(this);
                            inst.init();
                        });
                    }
                });
            }
        });
    }
    LoadExplorerParameter() {
        return Bao.post("Explorer/GetAdditionalExplorerTypeData", JSON.stringify({ explorerTypeId: this.ExplorerTypeId() }), (value) => {
            this.OpenAllowed(value.OpenAllowed);
            this.AllowedPermissions(value.AllowedPermissions);
            this.QuickFilterTemplate(value.QuickFilterTemplate);
        });
    }
    ;
    LoadHierarchy() {
        let def = $.Deferred();
        if (this.EnableTree()) {
            Bao.post("Explorer/GetExplorerHierarchyDefinitions", JSON.stringify({ explorerTypeId: this.ExplorerTypeId() }), (value) => {
                this.ExplorerHierarchy(value);
            }).always(() => {
                def.resolve();
            });
            ;
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    LoadFilter() {
        let def = $.Deferred();
        Bao.post("Explorer/GetExplorerFilters", JSON.stringify({ explorerTypeId: this.ExplorerTypeId() }), (value) => {
            this.ExplorerFilters(value);
        }).always(() => {
            def.resolve();
        });
        ;
        return def.promise();
    }
    ;
    GetTemplate() {
        let def = $.Deferred();
        if (this.EnableTree() == false) {
            Bao.post("Explorer/GetTemplate", JSON.stringify({ explorerTypeId: this.ExplorerTypeId() }), (value) => {
                let templateName = "explorertype" + this.ExplorerTypeId();
                Bao.Templates[templateName] = value;
                this.TemplateName(templateName);
            }).always(() => {
                def.resolve();
            });
            ;
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    LoadTree() {
        let def = $.Deferred();
        if (this.EnableTree() == true) {
            this.SelectedNode(null);
            this.SelectedRow(null);
            Bao.post("Explorer/InitTree", JSON.stringify({
                explorerTypeId: this.ExplorerTypeId(),
                explorerHierarchyDefinitionId: this.HierarchyId(),
                explorerFilterId: this.FilterId(),
                jsonQuickFilter: ko.map.toJS(this.GetQuickFilter())
            }), (value) => {
                let newItems = [];
                if (value != null && value.length > 0) {
                    $.each(value, (index, row) => {
                        let node = new TreeNodeViewModel(row);
                        newItems[index] = node;
                    });
                }
                this.Nodes(newItems);
            }).always(() => {
                def.resolve();
            });
        }
        else {
            this.GetTemplate()
                .then(() => {
                    return this.RefreshData();
                }).always(() => {
                    def.resolve();
                });
            ;
        }
        return def.promise();
    }
    ;
    LoadTreeChildren = (item) => {
        let def = $.Deferred();
        if (item.Loaded() == false) {
            this.TabPage.IsLoading(true);
            item.Loading(true);
            let jsItem = ko.map.toJS(item, false, false);
            let quickFilter = ko.map.toJS(this.GetQuickFilter());
            let param = JSON.stringify({
                explorerTypeId: this.ExplorerTypeId(),
                explorerHierarchyDefinitionId: this.HierarchyId(),
                explorerFilterId: this.FilterId(),
                node: jsItem,
                jsonQuickFilter: quickFilter
            });
            Bao.post("Explorer/GetTreeChildren", param, (value) => {
                let newItems = [];
                if (value != null && value.length > 0) {
                    $.each(value, (index, row) => {
                        let node = new TreeNodeViewModel(row);
                        newItems[index] = node;
                    });
                    item.Nodes(newItems);
                }
                item.Loading(false);
                item.Opened(true);
                item.Loaded(true);
                this.TabPage.IsLoading(false);
            }).always(() => {
                def.resolve();
            });
            ;
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    RefreshData(resetIndex = false) {
        let selectedNode = ko.map.toJS(this.SelectedNode(), false, false);

        if (selectedNode != null) {
            selectedNode.Nodes = null;
        }
        else {
            selectedNode = null;
        }
        if (resetIndex === true) {
            this._ignorePageIndexChange = true;
            this.PageIndex(0);
            this._ignorePageIndexChange = false;
        }
        this.TabPage.IsLoading(true);
        return Bao.post("Explorer/GetData", JSON.stringify({
            explorerTypeId: this.ExplorerTypeId(),
            explorerLayoutId: null,
            explorerFilterId: this.FilterId(),
            node: selectedNode,
            jsonQuickFilter: ko.map.toJS(this.GetQuickFilter()),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (data) => {
            if (this.EnableTree()) {
                this.Models(data.Models);
                if (this.SelectedNode() != null) {
                    this.SelectedNode().Count(data.TotalRows);
                    this.SelectedNode().CountVisible(true);
                }
            }
            else if (data.Models != null) {
                    let array = [];
                    $.each(data.Models, (index, row) => {
                        let node = new NodeViewModel("", 0, row, row.OpenData, row.OpenUrl, this);
                        if (row.HasChildren == false) {
                            node.GridNodes([]);
                            node.Loaded(true);
                        }
                        array[index] = node;
                    });
                    this.Models(array);
                }
            
            this.TotalRows(data.TotalRows);
            this.TabPage.IsLoading(false);
        });
    }
    ;
    OpenNode = (item) => {
        if (item.Opened()) {
            item.Opened(false);
        }
        else {
            if (item.Loaded() == false) {
                this.TabPage.IsLoading(true);
                return Bao.post("Explorer/GetChildData", JSON.stringify({
                    explorerTypeId: this.ExplorerTypeId(),
                    explorerLayoutId: null,
                    explorerFilterId: this.FilterId(),
                    parentId: item.OpenData,
                    jsonQuickFilter: ko.map.toJS(this.GetQuickFilter()),
                    pageIndex: this.PageIndex(),
                    pageSize: this.PageSize(),
                    sorting: this.Sorting()
                }), (data) => {
                    let array = [];
                    $.each(data.Models, (index, row) => {
                        let node = new NodeViewModel("", item.Level + 1, row, row.OpenData, row.OpenUrl, this);
                        if (row.HasChildren == false) {
                            node.GridNodes([]);
                            node.Loaded(true);
                        }
                        array[index] = node;
                    });
                    item.GridNodes(array);
                    item.Loaded(true);
                    item.Opened(true);
                    this.TabPage.IsLoading(false);
                });
            }
            else {
                item.Opened(true);
            }
        }
    };
    LoadColumns() {
        return Bao.post("Explorer/GetColumns", JSON.stringify({
            explorerTypeId: this.ExplorerTypeId(),
            explorerLayoutId: null
        }), (columns) => {
            this.Columns(columns);
        });
    }
    ;
    ResetTreeAndGrid() {
        let def = $.Deferred();
        if (this.resetInProgress == false) {
            this.resetInProgress = true;
            this.ResetSearchValues();
            this.TabPage.IsLoading(true);
            if (this.EnableTree() == false) {
                this.RefreshData().always(() => {
                    this.TabPage.IsLoading(false);
                    this.resetInProgress = false;
                    def.resolve();
                });
            }
            else {
                this.LoadTree().always(() => {
                    this.TabPage.IsLoading(false);
                    this.resetInProgress = false;
                    def.resolve();
                });
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    ResetExplorer() {
        let def = $.Deferred();
        this.TabPage.IsLoading(true);
        this.resetInProgress = true;
        this.SelectedRow(null);
        this.FilterId(null);
        this.ResetSearchValues();
        $.when(this.LoadHierarchy(), this.LoadColumns(), this.LoadExplorerParameter()).always(() => {
            this.LoadFilter().always(() => {
                this.LoadTree().always(() => {
                    def.resolve();
                });
            });
        });
        def.always(() => {
            this.resetInProgress = false;
            this.TabPage.IsLoading(false);
        });
        return def.promise();
    }
    ;
    ToggleNode = (item) => {
        if (item.Loaded() == false) {
            this.LoadTreeChildren(item);
        }
        else {
            item.Opened(!item.Opened());
        }
    };
    ResetSearchValues() {
        this.TotalRows(0);
        this.PageIndex(0);
        this.Sorting([]);
        this.Models([]);
        this.Nodes([]);
        this.SelectedNode(null);
    }
    ;
    GetQuickFilter() {
        return this.QuickFilterJson;
    }
    ;
    GetExplorerTypeObject(explorerTypeKeyOrId) {
        let explorerType = null;
        for (let i = 0; i < this.ExplorerTypes().length; i++) {
            let item = this.ExplorerTypes()[i];
            if (ko.unwrap(item.ExplorerTypeKey).toLowerCase() == explorerTypeKeyOrId.toLowerCase() || ko.unwrap(item.ExplorerTypeId).toLowerCase() == explorerTypeKeyOrId.toLowerCase()) {
                explorerType = item;
                break;
            }
        }
        return explorerType;
    }
    ;
    UpdateValuesFromHash() {
        let urlExplorerTypeKey = baoRouter.getRouteValue("explorertype", this.TabPage);
        if (urlExplorerTypeKey != null) {
            let explorerType = this.GetExplorerTypeObject(urlExplorerTypeKey);
            if (explorerType != null) {
                this.ExplorerTypeId(ko.unwrap(explorerType.ExplorerTypeId));
            }
        }
    }
    ;
    /** Updates Hash-Url
    */
    UpdateHash() {
        if (this.TabPage.IsActiveTab()) {
            let explorerType = this.SelectedExplorerType();
            if (explorerType != null) {
                let newHash = "explorer/" + ko.unwrap(explorerType.ExplorerTypeKey).toLowerCase() + "/" + this.TabPage.ObjectId();
                let currentHash = baoRouter.getHash();
                if (newHash.toLowerCase() != currentHash.toLowerCase()) {
                    if (currentHash.toLowerCase() == "explorer/" + ko.unwrap(explorerType.ExplorerTypeKey).toLowerCase()) {
                        baoRouter.replaceHash(newHash);
                    }
                    else {
                        baoRouter.setHash(newHash);
                    }
                    this.TabPage.Route.request = newHash;
                }
            }
        }
    }
    ;
    Open(item, column) {
        if (Bao.Utils.String.IsNullOrWhitespace(column.OpenUrlProperty)) {
            if (this.OpenAllowed() == true && item != null) {
                if (item.OpenUrl.startsWith("#")) {
                    baoRouter.setHash(item.OpenUrl.substring(1));
                    this.TabPage.IsLoading(false);
                }
                else {
                    this.TabPage.IsLoading(true);
                    window.baorequire(["Factories/TabPage"], (TabPage) => {
                        let newTab = new TabPage();
                        newTab.Url(item.OpenUrl);
                        newTab.UrlData({ id: item.OpenData });
                        newTab.ObjectId(item.OpenData);
                        AppTabController.AddTab(newTab);
                        this.TabPage.IsLoading(false);
                    });
                }
            }
        }
        else {
            baoRouter.setHash(item[column.OpenUrlProperty].substring(1));
            this.TabPage.IsLoading(false);
        }
    }
    ;
    TabSelected = () => {
        this.UpdateValuesFromHash();
        this.UpdateHash();
    };
    EditFilter() {
        if (this.FilterId() != '00000000-0000-0000-0000-000000000000') {
            this.OpenFilterDialog(this.FilterId());
        }
    }
    ;
    NewFilter() {
        this.OpenFilterDialog(null);
    }
    ;
    TogglePermissions() {
        if (this.TabPage != null
            && this.TabPage.Context() != null
            && this.TabPage.Context().Container() != null
            && this.TabPage.Context().Container().length > 0
            && this.TabPage.Context().Container()[0].Buttons() != null) {
            ko.utils.arrayForEach(this.TabPage.Context().Container()[0].Buttons(), (button: any) => {
                button.Enabled(false);
            });
            ko.utils.arrayForEach(this.AllowedPermissions(), (allowedPermission) => {
                BaoMenu.permissionEnable({ ActionKey: allowedPermission, Enabled: true });
            });
        }
    }
    ;
    OpenFilterDialog(filterId) {
        this.TabPage.IsLoading(true);
        window.baorequire(['ViewModels/BaoDialog/ExplorerFilterDialog'], (vm) => {
            let dialog = new vm(this.TabPage, this);
            dialog.Show(filterId);
            dialog.DialogResult.subscribe((dialogResult) => {
                if (dialogResult == "ok") {
                    this.ResetExplorer();
                }
            });
        });
    }
    ;
    loaded() {
        let def = $.Deferred();
        this.TabPage.TabSelected = this.TabSelected;
        this.ResetExplorer().then(() => {
            this.Initialized(true);
            def.resolve();
        });
        return def.promise();
    }
    ;
    init() {
        this.TabPage.EnableDirtyTracking(false);
        this.TabPage.IsLoading(true);
        return Bao.post("Explorer/GetExplorerTypes", (result) => {
            this.ExplorerTypes(result);
            if (this.TabPage.ObjectId() == null) {
                this.TabPage.ObjectId(Guid());
            }
            this.TabPage.SessionTabId = this.TabPage.ObjectId();
            this.UpdateValuesFromHash();
            this.TabPage.IsLoading(false);
        });
    }
    ;
}
export default ExplorerViewModel;